import { render, staticRenderFns } from "./shop.vue?vue&type=template&id=b777def8&scoped=true"
import script from "./shop.vue?vue&type=script&lang=js"
export * from "./shop.vue?vue&type=script&lang=js"
import style0 from "./shop.vue?vue&type=style&index=0&id=b777def8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b777def8",
  null
  
)

export default component.exports